// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * RecoveryKeyModal Component Styles
 */

.recovery-key-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 10000;
  animation: modalFadeIn 0.2s ease;
}

.recovery-key-modal-container {
  background: #F0F0F0;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  width: 764px;
  max-width: 764px;
  max-height: 90vh;
  overflow-y: auto;
  animation: modalSlideIn 0.3s ease;
}

.recovery-key-modal-header {
  padding: 40px 35px 0;
  border-bottom: none;
  position: relative;
}

.recovery-key-modal-title {
  margin: 0;
  font-family: 'Open Sans', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #4B4B4B;
  text-align: center;
  line-height: 1.36181640625em;
}

.recovery-key-modal-close {
  background: #4A4A4A;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #FFFFFF;
  padding: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  position: absolute;
  right: 15px;
  top: 15px;
  line-height: 1;
}

.recovery-key-modal-close:hover {
  background: #333333;
}

.recovery-key-modal-content {
  padding: 45px 35px 40px;
  max-width: 694px;
  margin: 0 auto;
}

.recovery-key-modal-description {
  margin-bottom: 24px;
}

.recovery-key-modal-description p {
  margin: 0 0 24px;
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.36181640625em;
  color: #6A6A6A;
  text-align: center;
}

.recovery-key-example {
  background-color: rgba(216, 216, 216, 0.6);
  border: none;
  border-radius: 8px;
  padding: 10px;
  width: 600px;
  margin: 0 auto 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.recovery-key-example-label {
  display: block;
  font-family: 'SF Pro Display', -apple-system, sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #6A6A6A;
  margin-bottom: 0;
  text-transform: none;
  letter-spacing: normal;
  line-height: 1.5em;
}

.recovery-key-example-code {
  display: block;
  font-family: 'Andale Mono', 'Monaco', 'Courier New', monospace;
  font-size: 16px;
  color: #6A6A6A;
  word-break: break-all;
  letter-spacing: normal;
  line-height: 1.5em;
}

.recovery-key-form {
  margin-top: 24px;
}

.recovery-key-error {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 12px;
  background-color: #fee;
  border: 1px solid #fcc;
  border-radius: 6px;
  color: #c00;
  font-size: 14px;
  animation: shake 0.3s ease;
}

.recovery-key-error ion-icon {
  font-size: 20px;
  flex-shrink: 0;
}

.recovery-key-warning {
  margin-top: 12px;
  padding: 8px 12px;
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 6px;
  color: #856404;
  font-size: 14px;
  text-align: center;
}

.recovery-key-cooldown {
  margin-top: 12px;
  padding: 8px 12px;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 6px;
  color: #495057;
  font-size: 14px;
  text-align: center;
  font-weight: 500;
}

.recovery-key-modal-actions {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
  margin-top: 24px;
  width: 405px;
  margin-left: auto;
  margin-right: auto;
}

.recovery-key-btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 46px;
  min-height: 46px;
  line-height: 1.36181640625em;
}

.recovery-key-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.recovery-key-btn-primary {
  background-color: #DE4858;
  color: white;
  width: 195px;
}

.recovery-key-btn-primary:hover:not(:disabled) {
  background-color: #c93d4c;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(222, 72, 88, 0.3);
}

.recovery-key-btn-primary:active:not(:disabled) {
  transform: translateY(0);
}

.recovery-key-btn-secondary {
  background-color: transparent;
  color: #DE4858;
  border: 2px solid #DE4858;
  width: 195px;
}

.recovery-key-btn-secondary:hover:not(:disabled) {
  background-color: rgba(222, 72, 88, 0.1);
  border-color: #DE4858;
}

.recovery-key-btn-danger {
  background-color: #fff;
  color: #dc3545;
  border: 1px solid #dc3545;
}

.recovery-key-btn-danger:hover:not(:disabled) {
  background-color: #dc3545;
  color: white;
}

.recovery-key-separator {
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #4B4B4B;
  text-align: center;
  margin: 12px 0;
  line-height: 1.36181640625em;
}

.recovery-key-btn-alternative {
  background-color: transparent;
  color: #DE4858;
  border: 2px solid #DE4858;
  width: 256px;
  height: 46px;
  margin: 0 auto;
  display: flex;
}

.recovery-key-btn-alternative:hover:not(:disabled) {
  background-color: rgba(222, 72, 88, 0.1);
  border-color: #DE4858;
}

.recovery-key-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top-color: currentColor;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

.recovery-key-modal-footer {
  margin-top: 24px;
  padding-top: 0;
  border-top: none;
  text-align: center;
}

.recovery-key-footer-link {
  font-family: 'SF Pro Display', -apple-system, sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #DE4858;
  text-decoration: none;
  line-height: 1.193359375em;
  letter-spacing: 0.01em;
  display: inline-block;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: color 0.2s ease, text-decoration 0.2s ease;
}

.recovery-key-footer-link:hover {
  color: #c93d4c;
  text-decoration: underline;
}

.recovery-key-footer-link:focus {
  outline: 2px solid #DE4858;
  outline-offset: 2px;
}

.recovery-key-help-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #DE4858;
  text-decoration: none;
  font-size: 16px;
  font-family: 'SF Pro Display', -apple-system, sans-serif;
  font-weight: 500;
  line-height: 1.193359375em;
  letter-spacing: 0.01em;
  transition: color 0.2s ease;
}

.recovery-key-help-link:hover {
  color: #c93d4c;
  text-decoration: underline;
}

.recovery-key-help-link ion-icon {
  font-size: 18px;
}

/* Animations */
@keyframes modalFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translateX(-2px);
  }
  20%, 40%, 60%, 80% {
    transform: translateX(2px);
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Success indicator */
.recovery-key-success {
  width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 24px;
}

.recovery-key-success-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #51A73B;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: scaleIn 0.3s ease;
}

.recovery-key-success-icon ion-icon {
  font-size: 36px;
  color: #FFFFFF;
  --ionicon-stroke-width: 48px;
}

.recovery-key-success-message {
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #51A73B;
  text-align: center;
}

@keyframes scaleIn {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* Success state actions - centered column layout */
.recovery-key-modal-actions--success {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
  width: 300px;
  margin-left: auto;
  margin-right: auto;
}

.recovery-key-modal-actions--success .recovery-key-btn {
  width: 100%;
}

/* Export note - shown when recovery key not available for export */
.recovery-key-export-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 16px;
  padding: 12px;
  background-color: #e8f4fd;
  border: 1px solid #b8daff;
  border-radius: 6px;
  color: #004085;
  font-size: 13px;
  line-height: 1.4;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.recovery-key-export-note ion-icon {
  font-size: 18px;
  flex-shrink: 0;
  margin-top: 1px;
}

/* Dark theme */
@media (prefers-color-scheme: dark) {
  .recovery-key-modal-container {
    background: #1a1a1a;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  }

  .recovery-key-modal-header {
    border-bottom-color: #333;
  }

  .recovery-key-modal-title {
    color: #e0e0e0;
  }

  .recovery-key-modal-close {
    background: #666;
  }

  .recovery-key-modal-close:hover {
    background: #888;
  }

  .recovery-key-modal-description p {
    color: #aaa;
  }

  .recovery-key-example {
    background-color: #0d0d0d;
    border-color: #333;
  }

  .recovery-key-example-label {
    color: #999;
  }

  .recovery-key-example-code {
    color: #ccc;
  }

  .recovery-key-error {
    background-color: #2a0000;
    border-color: #4a0000;
    color: #ff6b6b;
  }

  .recovery-key-warning {
    background-color: #2a2000;
    border-color: #4a4000;
    color: #ffa500;
  }

  .recovery-key-cooldown {
    background-color: #0d0d0d;
    border-color: #333;
    color: #999;
  }

  .recovery-key-btn-primary {
    background-color: #0d6efd;
  }

  .recovery-key-btn-primary:hover:not(:disabled) {
    background-color: #0b5ed7;
  }

  .recovery-key-btn-secondary {
    background-color: #2a2a2a;
    color: #ccc;
    border-color: #444;
  }

  .recovery-key-btn-secondary:hover:not(:disabled) {
    background-color: #333;
    border-color: #555;
  }

  .recovery-key-btn-danger {
    background-color: #1a1a1a;
    color: #ff6b6b;
    border-color: #ff6b6b;
  }

  .recovery-key-btn-danger:hover:not(:disabled) {
    background-color: #dc3545;
    color: white;
  }

  .recovery-key-modal-footer {
    border-top-color: #333;
  }

  .recovery-key-help-link {
    color: #6cb3ff;
  }

  .recovery-key-help-link:hover {
    color: #4a9fff;
  }

  .recovery-key-success-icon {
    background-color: #51A73B;
  }

  .recovery-key-success-message {
    color: #6EBF5A;
  }

  .recovery-key-export-note {
    background-color: #1a2733;
    border-color: #2d4a5e;
    color: #8ec8f0;
  }
}

/* Mobile responsiveness */
@media (max-width: 640px) {
  .recovery-key-modal-overlay {
    padding: 0;
  }

  .recovery-key-modal-container {
    max-width: 100%;
    max-height: 100%;
    height: 100%;
    border-radius: 0;
  }

  .recovery-key-modal-header {
    padding: 20px;
  }

  .recovery-key-modal-title {
    font-size: 20px;
  }

  .recovery-key-modal-content {
    padding: 20px;
  }
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .recovery-key-modal-overlay,
  .recovery-key-modal-container,
  .recovery-key-error,
  .recovery-key-success-icon {
    animation: none;
  }

  .recovery-key-btn {
    transition: none;
  }

  .recovery-key-spinner {
    animation: spin 1.5s linear infinite;
  }
}

/* High contrast */
@media (prefers-contrast: high) {
  .recovery-key-modal-container {
    border: 2px solid currentColor;
  }

  .recovery-key-btn {
    border: 2px solid currentColor;
  }

  .recovery-key-error,
  .recovery-key-warning,
  .recovery-key-cooldown {
    border-width: 2px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Recovery/RecoveryKeyModal.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,wDAAwD;EACxD,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,8DAA8D;EAC9D,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wDAAwD;EACxD,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,0BAA0B;EAC1B,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,wDAAwD;EACxD,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,mBAAmB;IACnB,0CAA0C;EAC5C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;EAChB;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,mBAAmB;AACnB;EACE;;;;IAIE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oCAAoC;EACtC;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;;IAGE,iBAAiB;EACnB;AACF","sourcesContent":["/**\n * RecoveryKeyModal Component Styles\n */\n\n.recovery-key-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  z-index: 10000;\n  animation: modalFadeIn 0.2s ease;\n}\n\n.recovery-key-modal-container {\n  background: #F0F0F0;\n  border-radius: 20px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n  width: 764px;\n  max-width: 764px;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: modalSlideIn 0.3s ease;\n}\n\n.recovery-key-modal-header {\n  padding: 40px 35px 0;\n  border-bottom: none;\n  position: relative;\n}\n\n.recovery-key-modal-title {\n  margin: 0;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  color: #4B4B4B;\n  text-align: center;\n  line-height: 1.36181640625em;\n}\n\n.recovery-key-modal-close {\n  background: #4A4A4A;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: #FFFFFF;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n  position: absolute;\n  right: 15px;\n  top: 15px;\n  line-height: 1;\n}\n\n.recovery-key-modal-close:hover {\n  background: #333333;\n}\n\n.recovery-key-modal-content {\n  padding: 45px 35px 40px;\n  max-width: 694px;\n  margin: 0 auto;\n}\n\n.recovery-key-modal-description {\n  margin-bottom: 24px;\n}\n\n.recovery-key-modal-description p {\n  margin: 0 0 24px;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 1.36181640625em;\n  color: #6A6A6A;\n  text-align: center;\n}\n\n.recovery-key-example {\n  background-color: rgba(216, 216, 216, 0.6);\n  border: none;\n  border-radius: 8px;\n  padding: 10px;\n  width: 600px;\n  margin: 0 auto 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.recovery-key-example-label {\n  display: block;\n  font-family: 'SF Pro Display', -apple-system, sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: #6A6A6A;\n  margin-bottom: 0;\n  text-transform: none;\n  letter-spacing: normal;\n  line-height: 1.5em;\n}\n\n.recovery-key-example-code {\n  display: block;\n  font-family: 'Andale Mono', 'Monaco', 'Courier New', monospace;\n  font-size: 16px;\n  color: #6A6A6A;\n  word-break: break-all;\n  letter-spacing: normal;\n  line-height: 1.5em;\n}\n\n.recovery-key-form {\n  margin-top: 24px;\n}\n\n.recovery-key-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 12px;\n  padding: 12px;\n  background-color: #fee;\n  border: 1px solid #fcc;\n  border-radius: 6px;\n  color: #c00;\n  font-size: 14px;\n  animation: shake 0.3s ease;\n}\n\n.recovery-key-error ion-icon {\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.recovery-key-warning {\n  margin-top: 12px;\n  padding: 8px 12px;\n  background-color: #fff3cd;\n  border: 1px solid #ffc107;\n  border-radius: 6px;\n  color: #856404;\n  font-size: 14px;\n  text-align: center;\n}\n\n.recovery-key-cooldown {\n  margin-top: 12px;\n  padding: 8px 12px;\n  background-color: #e9ecef;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  color: #495057;\n  font-size: 14px;\n  text-align: center;\n  font-weight: 500;\n}\n\n.recovery-key-modal-actions {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 24px;\n  width: 405px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.recovery-key-btn {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 46px;\n  min-height: 46px;\n  line-height: 1.36181640625em;\n}\n\n.recovery-key-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.recovery-key-btn-primary {\n  background-color: #DE4858;\n  color: white;\n  width: 195px;\n}\n\n.recovery-key-btn-primary:hover:not(:disabled) {\n  background-color: #c93d4c;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(222, 72, 88, 0.3);\n}\n\n.recovery-key-btn-primary:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.recovery-key-btn-secondary {\n  background-color: transparent;\n  color: #DE4858;\n  border: 2px solid #DE4858;\n  width: 195px;\n}\n\n.recovery-key-btn-secondary:hover:not(:disabled) {\n  background-color: rgba(222, 72, 88, 0.1);\n  border-color: #DE4858;\n}\n\n.recovery-key-btn-danger {\n  background-color: #fff;\n  color: #dc3545;\n  border: 1px solid #dc3545;\n}\n\n.recovery-key-btn-danger:hover:not(:disabled) {\n  background-color: #dc3545;\n  color: white;\n}\n\n.recovery-key-separator {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  color: #4B4B4B;\n  text-align: center;\n  margin: 12px 0;\n  line-height: 1.36181640625em;\n}\n\n.recovery-key-btn-alternative {\n  background-color: transparent;\n  color: #DE4858;\n  border: 2px solid #DE4858;\n  width: 256px;\n  height: 46px;\n  margin: 0 auto;\n  display: flex;\n}\n\n.recovery-key-btn-alternative:hover:not(:disabled) {\n  background-color: rgba(222, 72, 88, 0.1);\n  border-color: #DE4858;\n}\n\n.recovery-key-spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid transparent;\n  border-top-color: currentColor;\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n}\n\n.recovery-key-modal-footer {\n  margin-top: 24px;\n  padding-top: 0;\n  border-top: none;\n  text-align: center;\n}\n\n.recovery-key-footer-link {\n  font-family: 'SF Pro Display', -apple-system, sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  color: #DE4858;\n  text-decoration: none;\n  line-height: 1.193359375em;\n  letter-spacing: 0.01em;\n  display: inline-block;\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  transition: color 0.2s ease, text-decoration 0.2s ease;\n}\n\n.recovery-key-footer-link:hover {\n  color: #c93d4c;\n  text-decoration: underline;\n}\n\n.recovery-key-footer-link:focus {\n  outline: 2px solid #DE4858;\n  outline-offset: 2px;\n}\n\n.recovery-key-help-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #DE4858;\n  text-decoration: none;\n  font-size: 16px;\n  font-family: 'SF Pro Display', -apple-system, sans-serif;\n  font-weight: 500;\n  line-height: 1.193359375em;\n  letter-spacing: 0.01em;\n  transition: color 0.2s ease;\n}\n\n.recovery-key-help-link:hover {\n  color: #c93d4c;\n  text-decoration: underline;\n}\n\n.recovery-key-help-link ion-icon {\n  font-size: 18px;\n}\n\n/* Animations */\n@keyframes modalFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes shake {\n  0%, 100% {\n    transform: translateX(0);\n  }\n  10%, 30%, 50%, 70%, 90% {\n    transform: translateX(-2px);\n  }\n  20%, 40%, 60%, 80% {\n    transform: translateX(2px);\n  }\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Success indicator */\n.recovery-key-success {\n  width: 600px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding: 24px;\n}\n\n.recovery-key-success-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background-color: #51A73B;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: scaleIn 0.3s ease;\n}\n\n.recovery-key-success-icon ion-icon {\n  font-size: 36px;\n  color: #FFFFFF;\n  --ionicon-stroke-width: 48px;\n}\n\n.recovery-key-success-message {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  color: #51A73B;\n  text-align: center;\n}\n\n@keyframes scaleIn {\n  from {\n    transform: scale(0);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Success state actions - centered column layout */\n.recovery-key-modal-actions--success {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  margin-top: 24px;\n  width: 300px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.recovery-key-modal-actions--success .recovery-key-btn {\n  width: 100%;\n}\n\n/* Export note - shown when recovery key not available for export */\n.recovery-key-export-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-top: 16px;\n  padding: 12px;\n  background-color: #e8f4fd;\n  border: 1px solid #b8daff;\n  border-radius: 6px;\n  color: #004085;\n  font-size: 13px;\n  line-height: 1.4;\n  max-width: 400px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.recovery-key-export-note ion-icon {\n  font-size: 18px;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n/* Dark theme */\n@media (prefers-color-scheme: dark) {\n  .recovery-key-modal-container {\n    background: #1a1a1a;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);\n  }\n\n  .recovery-key-modal-header {\n    border-bottom-color: #333;\n  }\n\n  .recovery-key-modal-title {\n    color: #e0e0e0;\n  }\n\n  .recovery-key-modal-close {\n    background: #666;\n  }\n\n  .recovery-key-modal-close:hover {\n    background: #888;\n  }\n\n  .recovery-key-modal-description p {\n    color: #aaa;\n  }\n\n  .recovery-key-example {\n    background-color: #0d0d0d;\n    border-color: #333;\n  }\n\n  .recovery-key-example-label {\n    color: #999;\n  }\n\n  .recovery-key-example-code {\n    color: #ccc;\n  }\n\n  .recovery-key-error {\n    background-color: #2a0000;\n    border-color: #4a0000;\n    color: #ff6b6b;\n  }\n\n  .recovery-key-warning {\n    background-color: #2a2000;\n    border-color: #4a4000;\n    color: #ffa500;\n  }\n\n  .recovery-key-cooldown {\n    background-color: #0d0d0d;\n    border-color: #333;\n    color: #999;\n  }\n\n  .recovery-key-btn-primary {\n    background-color: #0d6efd;\n  }\n\n  .recovery-key-btn-primary:hover:not(:disabled) {\n    background-color: #0b5ed7;\n  }\n\n  .recovery-key-btn-secondary {\n    background-color: #2a2a2a;\n    color: #ccc;\n    border-color: #444;\n  }\n\n  .recovery-key-btn-secondary:hover:not(:disabled) {\n    background-color: #333;\n    border-color: #555;\n  }\n\n  .recovery-key-btn-danger {\n    background-color: #1a1a1a;\n    color: #ff6b6b;\n    border-color: #ff6b6b;\n  }\n\n  .recovery-key-btn-danger:hover:not(:disabled) {\n    background-color: #dc3545;\n    color: white;\n  }\n\n  .recovery-key-modal-footer {\n    border-top-color: #333;\n  }\n\n  .recovery-key-help-link {\n    color: #6cb3ff;\n  }\n\n  .recovery-key-help-link:hover {\n    color: #4a9fff;\n  }\n\n  .recovery-key-success-icon {\n    background-color: #51A73B;\n  }\n\n  .recovery-key-success-message {\n    color: #6EBF5A;\n  }\n\n  .recovery-key-export-note {\n    background-color: #1a2733;\n    border-color: #2d4a5e;\n    color: #8ec8f0;\n  }\n}\n\n/* Mobile responsiveness */\n@media (max-width: 640px) {\n  .recovery-key-modal-overlay {\n    padding: 0;\n  }\n\n  .recovery-key-modal-container {\n    max-width: 100%;\n    max-height: 100%;\n    height: 100%;\n    border-radius: 0;\n  }\n\n  .recovery-key-modal-header {\n    padding: 20px;\n  }\n\n  .recovery-key-modal-title {\n    font-size: 20px;\n  }\n\n  .recovery-key-modal-content {\n    padding: 20px;\n  }\n}\n\n/* Reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  .recovery-key-modal-overlay,\n  .recovery-key-modal-container,\n  .recovery-key-error,\n  .recovery-key-success-icon {\n    animation: none;\n  }\n\n  .recovery-key-btn {\n    transition: none;\n  }\n\n  .recovery-key-spinner {\n    animation: spin 1.5s linear infinite;\n  }\n}\n\n/* High contrast */\n@media (prefers-contrast: high) {\n  .recovery-key-modal-container {\n    border: 2px solid currentColor;\n  }\n\n  .recovery-key-btn {\n    border: 2px solid currentColor;\n  }\n\n  .recovery-key-error,\n  .recovery-key-warning,\n  .recovery-key-cooldown {\n    border-width: 2px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
